<div class="multi-context-main">
    <div class="title-panel">
        Múltiplos Contextos
    </div>
    <mat-divider></mat-divider>
    <div class="info">
        Múltiplos Contexto de Execução do Fluxo
    </div>
    <mat-divider></mat-divider>
    <ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" name='main-context'>
    </ngx-spinner>
    <mat-toolbar>
        <mat-toolbar-row>
            <div class="bar-main-context">
                <button mat-mini-fab  color="primary" matTooltip="Adicionar" matTooltipClass="toolTip-request"  (click)="add()" *ngIf="!editMode"  [disabled]="!canInsert"> 
                    <mat-icon  aria-hidden="false" >add</mat-icon>
                </button>
                <button mat-mini-fab color="warn"  matTooltip="Remover" *ngIf="!editMode" (click)="remove()" matTooltipClass="toolTip-request" [disabled]="!canDelete">
                    <mat-icon>delete</mat-icon>
                </button>
                <button mat-mini-fab color="success" matTooltip="Salvar" matTooltipClass="toolTip-request"  (click)="save()" *ngIf="editMode" [disabled]="!canEdit"> 
                    <mat-icon  aria-hidden="false" >check</mat-icon>
                </button>
                <button mat-mini-fab  color="accent" matTooltip="Cancelar" matTooltipClass="toolTip-request"  (click)="cancel()" *ngIf="editMode" > 
                    <mat-icon  aria-hidden="accent" >close</mat-icon>
                </button>
                <mat-divider [vertical]="true" *ngIf="!editMode" ></mat-divider>
                <button mat-mini-fab  color="accent" matTooltip="Atualizar" matTooltipClass="toolTip-request"  (click)="refresh()" *ngIf="!editMode" [disabled]="!canView"> 
                    <mat-icon  aria-hidden="accent" >refresh</mat-icon>
                </button>
                <div class="cfg-text">{{data['IDCONF']}} - {{data['NAME']}}</div>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
    <mat-divider [vertical]="false"></mat-divider>
    
    <div class="cfg-main mat-elevation-z8" *ngIf="!editMode">
        <ag-grid-angular
            style="width: 100%; height: 100%"
            [class]="(ThemeService.theme)? 'ag-theme-quartz-dark':'ag-theme-quartz'"
            [rowData]="cfgcompany"
            [columnDefs]="displayedColumns"
            (gridReady)="onGridReady($event)"
            (rowDoubleClicked)="selectRow($event)"
            (rowClicked)="eventGridSelect($event)"
            [localeText]="ls.getCurrentGridLocale()"
            overlayNoRowsTemplate="Não encontrado nenhum resultado"
            rowBuffer="150"
            rowSelection="multiple"
            cacheBlockSize= "100"
            cacheOverflowSize="2"
            maxBlocksInCache= 10
            resizable="true"
            [pagination]="true"
            [enableCellTextSelection]="true"
            [suppressClipboardPaste]="true"
            [multiSortKey]="true">
        </ag-grid-angular>
    </div>
    <div class="multi-context-edit" *ngIf="editMode">
        <div class="more-options">
            <mat-slide-toggle   [(ngModel)]="active"  [ngModelOptions]="{standalone: true}" (change)="onToggleChange('ACTIVE')">Ativo
            </mat-slide-toggle>
        </div>
        <mat-divider [vertical]="false"></mat-divider>
        <search-input  [loaddesc]="true" ignoreDefCondition="false" entityname="Mktpcompanies" [form]="editForm"   entitydesc="Empresas" controlname="CODECOMPANY" placeholder="Empresa"  columnname="CODECOMPANY" class="no-padding-form-field-5px" [required]="true" >
        </search-input> 
        
          <input-button-popup
            [controle]="editForm.get('SCHEDULE')"
            label="Agendador" 
            type='text'
            icon='alarm'
            required="true"
            [component]="cronComponent"
            (result)="formSubmitted($event)" 
            ></input-button-popup>

            <mat-form-field [formGroup]="editForm">
                <mat-label>Servidor</mat-label>
                <mat-select formControlName="SERVERNAME" >
                  <mat-option *ngFor="let server of servers" [value]="server['HOSTNAME']">
                    {{server['NAME']}}
                  </mat-option>
                </mat-select>
            </mat-form-field>
    </div>
</div>